import { useRef } from 'react';

export const ZOOM_TO_FIT_ANIMATION_DURATION_MS = 300;

export const usePrefersReducedMotionRef = () =>
  useRef(typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
